import React from 'react';
import { Container } from 'reactstrap';
import { Link } from 'gatsby';

import CollapsibleCard from '../../../CollapsibleCard';
import { CONTACT_ROUTE } from '../../../../routes';

import squaresLeft from '../../../../images/background/process-squares-left.svg';
import squaresRight from '../../../../images/background/process-squares-right.svg';

const STEPS = [
  {
    title: 'New to AWS',
    stripeColor: 'orange',
    items: [
      'Design & Architectural Assistance',
      'AWS Build, Configuration & Integration',
      'Infrastructure Modification & Consolidation',
      'Cloud Migration Strategy',
      'Ondemand Solution Architects',
    ],
  },
  {
    title: 'Already On AWS',
    stripeColor: 'blue',
    items: [
      'Well-Architected Reviews',
      'Account Optimization',
      'Environment Restructure & Rebuild',
      'AWS Service Modernization',
      'Compliance',
    ],
  },
];

const CloudServices = ({ servicesRef }) => {
  return (
    <div className="Process CloudServices" ref={servicesRef}>
      <img src={squaresLeft} alt="bg" className="Process__leftSquares" />
      <img src={squaresRight} alt="bg" className="Process__rightSquares" />

      <Container>
        <h2 className="Process__title">
          AWS Cloud&nbsp;
          <span className="text-dark-blue">Services</span>
        </h2>

        <div className="Process__lead">Choose your path for starting a services engagement with us</div>

        <div className="d-flex flex-column flex-md-row flex-md-wrap align-items-md-stretch">
          {STEPS.map((item, idx) => (
            <div
              className="w-100 w-md-50 mb-3 pl-md-2 pr-md-2 pl-lg-3 pr-lg-3"
              key={idx}
            >
              <CollapsibleCard {...item} isOpenDefault>
                <Link to={CONTACT_ROUTE} className="CollapsibleCard__learnMore">
                  Get Started Now
                </Link>
              </CollapsibleCard>
            </div>
          ))}
        </div>
      </Container>
    </div>
  );
};

export default CloudServices;
